// Utility GDPR cookie consent — OnSports (CRA port di lib/cookie-consent.ts)

const CONSENT_KEY = "onsports-cookie-consent";
const CONSENT_VERSION = "1.0";
const CONSENT_CHANGE_EVENT = "onsports-consent-change";
const OPEN_BANNER_EVENT = "onsports-open-banner";

/**
 * Shape ConsentState:
 *   { necessary: true, statistics: boolean, marketing: boolean,
 *     timestamp: string ISO, version: string }
 */

export function getConsent() {
  if (typeof window === "undefined") return null;
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) return null;
    const parsed = JSON.parse(stored);
    if (parsed.version !== CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setConsent(prefs) {
  const consent = {
    necessary: true,
    statistics: !!prefs.statistics,
    marketing: !!prefs.marketing,
    timestamp: new Date().toISOString(),
    version: CONSENT_VERSION,
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  window.dispatchEvent(
    new CustomEvent(CONSENT_CHANGE_EVENT, { detail: consent })
  );
}

export function subscribeConsent(callback) {
  const handler = (e) => callback(e.detail);
  window.addEventListener(CONSENT_CHANGE_EVENT, handler);
  return () => window.removeEventListener(CONSENT_CHANGE_EVENT, handler);
}

export function openConsentBanner() {
  window.dispatchEvent(new CustomEvent(OPEN_BANNER_EVENT));
}

export function subscribeOpenBanner(callback) {
  const handler = () => callback();
  window.addEventListener(OPEN_BANNER_EVENT, handler);
  return () => window.removeEventListener(OPEN_BANNER_EVENT, handler);
}
